import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BehaviorSubject, Observable, Observer } from "rxjs";
import { Messages } from "../../../model/messages";
import { Involved } from "../../../model/involved";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SingleChoice } from "../../../model/singlechoice";
import { Ticket } from "../../../model/ticket";
import { InvolvedService } from "../../../services/involved.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { NavigationHelper } from "../../../services/navigation.helper";
import { UsersService } from "../../../services/users.service";
import { Navigation } from "../../../model/navigation";
import { ActionButtonSubmit } from "../../../model/action-button-submit";
import { TicketService } from "../../../services/ticket.service";
import { Labeler } from "../../../model/labeler";
@Component({
  selector: "involved-details",

  templateUrl: "./involved-details.component.html",
  styleUrl: "./involved-details.component.css",
})
export class InvolvedDetailsComponent implements OnInit {
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  involved = new BehaviorSubject<Involved>(new Involved(0, 0, ""));
  editMode: boolean = false;
  involvedForm: FormGroup;
  involvedTitle: string = "involvedDetails.title.involved.details";
  @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
  @Input() currentTicket: Observable<Ticket>;
  ticket: Ticket | null = null;

  userIdLabeler = new BehaviorSubject<string>("-");

  currentId: number | null;
  involveds: BehaviorSubject<Involved[]> = new BehaviorSubject<Involved[]>([]);
  completionUrl = new BehaviorSubject<string>("");
  isLoading: boolean = false;
  stateGuard: boolean;
  involvedBackup: Ticket | null = null;
  @Output() formClosed = new EventEmitter<void>();
  showSaveButton: boolean = true;
  constructor(
    private ticketService: TicketService,
    private involvedService: InvolvedService,
    private auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper,
    private users: UsersService
  ) {}

  ngOnInit(): void {
    this.involvedService.involvedObservable.subscribe((involved) => {
      this.involveds.next(involved);
    });
    this.initializeForm();
    this.involvedForm.valueChanges.subscribe((formValue) => {
      if (!this.stateGuard) {
        this.stateGuard = true;

        this.stateGuard = false;
      }
    });

    this.involvedService.formState.subscribe((restoredState) => {
      if (this.stateGuard) {
      } else if (this.editMode) {
        this.restoreFormValues(restoredState);
      }
    });
    this.involved.subscribe((involved) => {
      this.userIdLabeler.next(this.userLabel);
    });

    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentId = ticket.id;
        this.ticket = ticket;
      });
    }

    if (Navigation.NEW.toString() === this.nav.current.fragmentId) {
      this.editMode = true;
      this.involvedForm.reset();

      this.involvedTitle = "involvedDetails.title.new.involved";
    }

    const restoredState = this.involvedService.restoreFormState();

    this.involvedService.selectedInvolvedObservable.subscribe(
      (selectedInvolved) => {
        if (selectedInvolved) {
          const oldGuard = this.stateGuard;
          this.stateGuard = true;
          const restored = this.involvedService.restoreFormState();
          if (restored.involved) {
            selectedInvolved.involved = restored.involved;
          }
          this.populateForm(selectedInvolved);
          this.completionUrl.next(
            "tickets/" +
              this.currentId +
              "/fragmentedit/involved/" +
              selectedInvolved.id
          );
        }
      }
    );

    if (
      !(
        this.involvedService.currentInvolved &&
        this.involvedService.currentInvolved.id &&
        this.involvedService.currentInvolved.id > 0
      )
    ) {
      this.involvedService.selectFromRouter();
    }
    this.nav.fragmentId.subscribe((id) => {
      if (
        this.nav.currentFragmentTopic === "involved" &&
        (id === "-9" || Number(id) > 0)
      ) {
        const fragmentId = Number(id);

        if (fragmentId > 0) {
          const action = this.nav.currentAction;

          if (action === "fragment") {
            this.editMode = false;
          } else if (
            action === "fragmentedit" &&
            fragmentId === Navigation.NEW
          ) {
            this.editMode = true;
          } else if (action === "fragmentedit") {
            this.editMode = true;
          }
        }
      }
    });
  }

  restoreFormValues(restoredState: Partial<Involved>) {
    if (Object.keys(restoredState).length > 0) {
    }
  }
  private initializeForm(): void {
    this.involvedForm = this.fb.group({
      involved: "",
    });
  }

  private populateForm(involved: Involved): void {
    this.involved.next(involved);
    this.involvedForm.patchValue({
      involved: involved.involved,
    });

    this.editMode = involved.id === Navigation.NEW;
    this.involvedTitle = this.editMode
      ? "involvedDetails.title.new.involved"
      : "involvedDetails.title.involved.details";
  }

  toggleEditMode() {
    this.formClosed.emit();
    if (this.editMode) {
      this.editMode = false;
      this.involvedService.clearFormStateBackup();
      this.involved.next(Involved.EMPTY);
      this.involvedForm.reset();
      this.involvedTitle = "involvedDetails.title";
    } else {
      this.router.navigate([
        "tickets/" +
          this.currentId +
          "/fragmentedit/involved/" +
          this.involvedId,
      ]);
      this.editMode = true;
    }
  }

  saveInvolved(action: ActionButtonSubmit): void {
    this.isLoading = true;
    this.formClosed.emit();
    if (this.involvedForm.valid) {
      const token = this.auth.token;
      const ticketId = this.currentId;

      if (ticketId == null) {
        return;
      }

      const formValues = this.involvedForm.value;

      const involvedId =
        this.involved.value.id && this.involved.value.id >= 1
          ? this.involved.value.id
          : Navigation.NEW;

      const updatedInvolved = new Involved(
        involvedId,
        ticketId,
        formValues.involved
      );

      this.involvedService
        .createInvolved(token, ticketId, updatedInvolved)
        .subscribe((messages) => {
          this.updatedInvolved(messages, action, ticketId, token);
        });
    } else {
    }
  }

  updatedInvolved(
    messages: Messages,
    action: ActionButtonSubmit,
    ticketId: number,
    token: string
  ) {
    this.isLoading = false;
    this.messages.next(messages);
    if (messages.hasAnyMessages) {
      action.result(false);
    } else {
      action.result(true);
      this.involvedService.clearFormStateBackup();
      this.ticketService
        .getTicketWithParts(token, ticketId, this.ticket || undefined)
        .subscribe((messages) => {
          this.messages.next(messages);
        });
      const involved = this.involvedService.currentInvolved;
      const involvedId: number = involved.id;
      const url =
        "tickets/" + this.currentId + "/fragment/involved/" + involvedId;
      this.router.navigate([url]);
    }
  }

  relaySingleChoice(choice: SingleChoice) {
    this.showSaveButton = true;
    this.nav.startChoice(choice);
  }

  userIdObserver: Partial<Observer<number>> = {
    next: (value: number) => {
      this.involvedForm.patchValue({ involved: value });
      this.involvedService.setFormState(this.involvedForm.value);
    },
  };

  onUserIdChoice(involved: string): void {
    const current = this.involved.value;
    current.involved = involved;
    this.involved.next(current);
    this.involvedService.restoreFormState();

    this.editMode = true;
  }

  get userId(): string {
    const involved = this.involved.value;
    return involved && involved.involved ? involved.involved : "-1";
  }
  get involvedId(): number {
    const involved = this.involved.value;
    return involved && involved.id ? involved.id : Navigation.NEW;
  }
  get userLabel(): string {
    const idStr = this.userId;
    const id = Number(idStr);
    let label = "-";
    if (!isNaN(id)) {
      label = this.users.labelForId(id);
    }
    return label;
  }

  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }
  get userIdLabelerByService(): Labeler {
    return this.users;
  }
  get showInvolved(): boolean {
    return this.involved.value.id !== 0 || this.editMode;
  }
}
